import { create } from 'zustand';

interface LoadingState {
	loading: boolean;
	startLoading: () => void;
	stopLoading: () => void;
	setLoading: (loading: boolean) => void;
}

// Internal type to track reference count without exposing it in the public interface
type LoadingStateInternal = LoadingState & { activeCount: number };

let debounceTimer: ReturnType<typeof setTimeout> | null = null;

const useLoadingStore = create<LoadingState>((set, get) => ({
	loading: false,

	startLoading: () => {
		if (debounceTimer) {
			clearTimeout(debounceTimer);
			debounceTimer = null;
		}
		set((state) => ({ loading: true, activeCount: ((state as LoadingStateInternal).activeCount ?? 0) + 1 }));
	},

	stopLoading: () => {
		set((state) => {
			const newCount = Math.max(0, ((state as LoadingStateInternal).activeCount ?? 1) - 1);
			if (newCount === 0) {
				debounceTimer = setTimeout(() => {
					set({ loading: false });
					debounceTimer = null;
				}, 150);
			}
			return { activeCount: newCount } as Partial<LoadingState>;
		});
	},

	// Backward compatible shim - existing callers (useCustomQuery, useAsyncAction, etc.) continue to work
	setLoading: (loading: boolean) => {
		if (loading) get().startLoading();
		else get().stopLoading();
	}
}));

export default useLoadingStore;
